module.exports = __webpack_public_path__ + "img/commodity.982b14be.png";